/**
 * One look for "this section has no data yet, here's what to do about it".
 *
 * Used across Campaigns / Inbox / Analytics / Documents so the blank-cabinet
 * mode feels like an intentional welcome screen instead of "the page broke."
 */
import { type ReactNode } from "react";
import { Link } from "react-router-dom";

export function EmptyState({
  icon, title, description, primaryCta, secondaryLink,
}: {
  icon: ReactNode;
  title: string;
  description: string | ReactNode;
  primaryCta?: { label: string; to?: string; onClick?: () => void };
  secondaryLink?: { label: string; to: string };
}) {
  return (
    <div className="grid place-items-center text-center py-16 px-4">
      <div className="w-16 h-16 rounded-full bg-lime/20 grid place-items-center mb-5 text-ink-60">
        {icon}
      </div>
      <h2 className="font-display font-extrabold text-[22px] tracking-tight mb-2 max-w-[460px]">{title}</h2>
      <div className="text-[14px] text-ink-60 leading-relaxed max-w-[480px] mb-6">
        {description}
      </div>
      <div className="flex items-center gap-3 flex-wrap justify-center">
        {primaryCta && (primaryCta.to ? (
          <Link to={primaryCta.to}
            className="inline-flex items-center gap-1.5 h-11 px-5 rounded-pill bg-lime text-[var(--fg-on-accent)] font-display font-semibold text-[14px] hover:[background:color-mix(in_srgb,var(--wb-lime)_88%,black)]">
            {primaryCta.label}
          </Link>
        ) : (
          <button onClick={primaryCta.onClick}
            className="inline-flex items-center gap-1.5 h-11 px-5 rounded-pill bg-lime text-[var(--fg-on-accent)] font-display font-semibold text-[14px] hover:[background:color-mix(in_srgb,var(--wb-lime)_88%,black)]">
            {primaryCta.label}
          </button>
        ))}
        {secondaryLink && (
          <Link to={secondaryLink.to} className="text-[13px] text-link hover:underline">
            {secondaryLink.label} →
          </Link>
        )}
      </div>
    </div>
  );
}
